import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { addHydrateReducer } from "../../utils/hydrateReducer";

export interface IBannerParams {
  isActive: boolean;
}

interface IBannersState {
  subscr: IBannerParams;
  onlyLitres: IBannerParams;
  promotion: IBannerParams;
  audioSubscr: IBannerParams;
  tvCampaignBanner: IBannerParams;
}

const initialState: IBannersState = {
  subscr: {
    isActive: false,
  },
  onlyLitres: {
    isActive: false,
  },
  promotion: {
    isActive: false,
  },
  audioSubscr: {
    isActive: false,
  },
  tvCampaignBanner: {
    isActive: false,
  },
};

export const bannersSlice = createSlice({
  name: "global/header/banners",
  initialState,
  reducers: {
    setSubscrBanner: (
      state: IBannersState,
      action: PayloadAction<IBannerParams>
    ) => {
      state.subscr.isActive = action.payload.isActive;
    },
    setOnlyLitresBanner: (
      state: IBannersState,
      action: PayloadAction<IBannerParams>
    ) => {
      state.onlyLitres.isActive = action.payload.isActive;
    },
    setPromotionBanner: (
      state: IBannersState,
      action: PayloadAction<IBannerParams>
    ) => {
      state.promotion.isActive = action.payload.isActive;
    },
    setAudioSubscrBanner: (
      state: IBannersState,
      action: PayloadAction<IBannerParams>
    ) => {
      state.audioSubscr.isActive = action.payload.isActive;
    },
    setTvCampaignBanner: (
      state: IBannersState,
      action: PayloadAction<IBannerParams>
    ) => {
      state.tvCampaignBanner.isActive = action.payload.isActive;
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.header.banners");
  },
});

export const {
  setSubscrBanner,
  setOnlyLitresBanner,
  setPromotionBanner,
  setAudioSubscrBanner,
  setTvCampaignBanner,
} = bannersSlice.actions;

export default bannersSlice.reducer;
